<div
  #banner
  class="banner"
  [style.background-image]="'url(' + backgroundImageUrl + ')'"
  [ngClass]="{
    'life-experience': prizeDetail,
    root__video: vipVideo,
    root__variant_banner: variant === 'banner'
  }"
  ata-testid="tournament-banner"
>
  <div class="banner__overlay"></div>

  <img
    *ngIf="prizeDetail"
    class="banner__triangle"
    src="{{ assetUrl }}/shared/img/triangle.png"
  />

  <div
    class="banner__container"
    [ngClass]="{
      container: variant === 'banner',
      promotion: variant === 'promotion'
    }"
  >
    <div class="banner__content">
      <div class="banner__content__game-avatar">
        <img [src]="gameImageUrl" fzSrcError="/shared/img/all-sports.webp" />
      </div>
      <div class="banner__content__tournament-about">
        <div
          *ngIf="isGameHistoryDetails"
          class="tournament-type-badge mat-caption"
        >
          {{ isLifeExperience ? 'Prize' : 'Cash' }} Tournament
        </div>
        <fz-tournament-countdown
          class="banner__content__tournament-countdown"
          *ngIf="isLifeExperience && startTime && endTime"
          [startDate]="startTime"
          [endDate]="endTime"
          [isEnded]="isCompleted"
          [timeZone]="timeZone"
          (handleEvent)="onEvent($event)"
        ></fz-tournament-countdown>
        <div class="banner__content__tournament-about__title">{{ title }}</div>
        <div class="banner__content__tournament-about__subtitle">
          {{ subtitle }}
        </div>
      </div>
      <div class="banner__content__actions" *ngIf="!isGameHistoryDetails">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
        <div
          *ngIf="startTime && endTime"
          class="banner__content__actions__dates"
        >
          <ng-container *ngTemplateOutlet="dates"></ng-container>
        </div>
      </div>
      <div
        *ngIf="startTime && endTime"
        class="banner__content__tournament-dates"
      >
        <ng-container *ngTemplateOutlet="dates"></ng-container>
      </div>
      <div
        *ngIf="vipVideo"
        class="banner__content__promotional-video banner__content__promotional-video__floating"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="openPromotionalVideo()"
          data-ga-value="banner-video-button"
          class="mat-button-legacy"
        >
          <img src="{{ assetUrl }}/shared/svg/clapperboard.svg" />
          <span>Watch <span>Promotional</span> Video</span>
        </button>
      </div>
      <div *ngIf="isZboOnly" class="banner__content__zbo-only">
        <img
          src="{{
            assetUrl
          }}/shared/img/tournaments/tournament_types/zbo_only_tournament.svg"
          alt="Tournament type"
        />
        <span>ZBO Only</span>
      </div>
      <div
        *ngIf="prizeDetail"
        [ngClass]="prizeImageOrientation"
        class="banner__content__prize-wrapper"
      >
        <div><img [src]="prizeDetail.prizeImageAvatar" /></div>
      </div>
    </div>
  </div>
</div>

<ng-template #dates>
  <div
    class="date"
    ngClass="mat-caption"
    matTooltip="{{ startTime | fzDateFormat: 'local' | async }}"
    matTooltipClass="info-tooltip"
  >
    <mat-icon>alarm</mat-icon>
    <span>
      From:
      <span class="small-date">{{
        startTime | fzDateFormat: 'small' | async
      }}</span>
      <span class="large-date">{{
        startTime | fzDateFormat: 'local' | async
      }}</span>
    </span>
  </div>
  <div
    class="date"
    ngClass="mat-caption"
    matTooltip="{{ endTime | fzDateFormat: 'local' | async }}"
    matTooltipClass="info-tooltip"
  >
    <mat-icon>alarm_on</mat-icon>
    <span>
      To:
      <span class="small-date">{{
        endTime | fzDateFormat: 'small' | async
      }}</span>
      <span class="large-date">{{
        endTime | fzDateFormat: 'local' | async
      }}</span>
    </span>
  </div>
</ng-template>

<!-- actions -->
<ng-template #actions>
  <fz-tournament-controls
    [showJoinButton]="actionBarOptions.showJoinButton"
    [showPlayButton]="actionBarOptions.showPlayButton"
    [enabledPlayButton]="actionBarOptions.enabledPlayButton"
    [playButtonLoading]="actionBarOptions.playButtonLoading"
    [isEventPage]="actionBarOptions.isEventPage"
    [showTryForFreeButton]="isTryForFreeEnabled"
    [showShareButton]="actionBarOptions.showShareButton"
    [showPlayButtonAnother]="actionBarOptions.showPlayButtonAnother"
    [isGameOverPage]="actionBarOptions.isGameOverPage"
    [casualGameStartTime]="startTime"
    [casualGameEndTime]="endTime"
    [entryAmount]="entryAmount"
    [userPass]="passForTournament"
    [eventScheduler]="eventScheduler"
    [user]="user"
    [tournament]="tournament"
    [tournamentDetails]="tournamentDetails"
    [responsive]="true"
    [playText]="playText"
    (joinPress)="onJoinButtonPress()"
    (sharePress)="onShareButtonPress()"
    (playPress)="onPlayButtonPress()"
    (tryForFreePress)="onTryForFreePress()"
    (playAnotherPress)="onPlayAnotherPress()"
  >
  </fz-tournament-controls>
</ng-template>
